<script setup lang="ts">
import { watch } from 'vue';
import { definePageMeta } from '#imports';
import { useState } from '#app/composables/state';
import { useRoute } from '#app/composables/router';
import { useSeoMeta } from '#app/composables/head';
import type { MenuDetailResponse } from '~~/server/api/kiwi_user/menus/detail';
import {
  menuDetailMiddleware,
  MENU_DETAIL_STATE_KEY,
} from '~/middleware/menuDetail';
import { useShowHistory } from '~/composables/useShowHistory';

definePageMeta({
  layout: 'recipe',
  middleware: menuDetailMiddleware,
});

const route = useRoute('public-article-menu-old_identifier');

const stateKey = `${MENU_DETAIL_STATE_KEY}-${route.params.old_identifier}`;
const data = useState<MenuDetailResponse | null>(stateKey, () => null);

// SEO設定
useSeoMeta({
  title: data.value?.title ?? '',
  description: data.value?.lead ?? '',
});

// 閲覧履歴保存（localStorageを使用するためクライアントサイドでのみ実行）
// NOTE: async setupではawaitの後にonMountedを登録するとinstance unavailableになるため、
// ライフサイクルフックを使わずwatchでデータが揃ったタイミングで保存する
if (import.meta.client) {
  const { saveShowHistory } = useShowHistory('menu');
  watch(
    () => data.value?.id,
    (id) => {
      if (id) {
        saveShowHistory(id);
      }
    },
    { immediate: true },
  );
}
</script>

<template>
  <OrganismsMenuDetailPage :menu-data="data" />
</template>
